var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7289 16H5.26438H5V18H7.39631H17.5969H20V16H19.7289Z",
    fill: "#EECC21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 3.93393L15.9387 9.3414C16.0264 9.47928 16.1759 9.56563 16.3392 9.57266C16.5024 9.57968 16.6588 9.50649 16.758 9.37664L20.259 4.79372L19.11 13.5H17.29H7.70365H5.89L4.74105 4.79372L8.24201 9.37664C8.3412 9.50648 8.49757 9.57967 8.6608 9.57266C8.82404 9.56564 8.97356 9.47932 9.06124 9.34145L12.5005 3.93393Z",
    fill: "#FFD60A",
    stroke: "#EECC21",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvFirst);
export default __webpack_public_path__ + "static/media/fv-first.ec5fd041c61771b72cb6d0b1aed4e752.svg";
export { ForwardRef as ReactComponent };